import { Box } from "@mui/material";
// sections
import OrderHero from "./OrderHero";
import ChoseOrder from "./ChoseOrder";
import KeyFeaturesCarousel from "./KeyFeaturesCarousel";
import Integration from "./Integration";

// ----------------------------------------------------------------------

export default function OrderManagement() {
  return (
    <>
      <Box>
        <OrderHero />
        <ChoseOrder />
        <KeyFeaturesCarousel />
        <Integration />
      </Box>
    </>
  );
}
